export default {
  customized: {
    label: 'カスタム画像＆ビデオ',
    filter: {
      network: {
        massive: '大量エンジン（今日のヘッドライン、穿山甲、TikTok）',
        engine: '今日のヘッドライン',
        tencent: 'Tencent Ads',
        baidu: 'Baidu InfoFlow',
        kuaishou: 'Kuaishou',
        wifi: 'WiFi Master Key',
        fan: 'FansTime',
        wechat: 'WeChat',
        mostright: 'Zuiyou',
        other: 'その他',
      },
    },
    describe:
      '私たちは高品質なクリエイティブのカスタマイズと多様なマーケティングプランニングサービスを提供し、さまざまなマーケティング目標とシーンに対応します。',
    table: {
      operation: {
        applytips: '製品をプッシュ',
      },
    },
  },
}
